import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  feedbackRoot: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: theme.palette.text.primary,
  },
  feedbackIconContainer: {
    paddingTop: '2px',
    paddingRight: '4px',
    display: 'inline-flex',
    alignItems: 'center',
  },
  checkmark: {
    fontSize: theme.typography.pxToRem(12),
  },
  positiveFeedback: {
    color: theme.palette.custom.green.light || '#00E676',
  },
  notSatisfiedFeedback: {
    color: theme.palette.text.secondary,
  },
}));
